const state = {
  promosData: [
    {
      id: 1,
      nombre_promo: "Ropa Vestir VIP",
      tipo_promo: "precio",
      tipo_item: "servicio",
      beneficiarios: "vip",
      codigo_item: 10001,
      precio_promo: 17.0,
      porcentaje_promo: 0,
      status: 1,
      id_usuario: 1,
      fecha_creacion: "",
      fecha_vencimiento: "",
      fecha: "2021-06-05 14:29:16"
    },
  ],
};

const getters = {
  demoPromos: state => state.promosData,
};

export default{
  state,
  getters
};